// extracted by mini-css-extract-plugin
export var content = "styles-module--content--16d7d";
export var fadeIn = "styles-module--fadeIn--27ed7";
export var githubIcon = "styles-module--githubIcon--3b877";
export var githubLink = "styles-module--githubLink--9ac70";
export var navButton = "styles-module--navButton--5d300";
export var navButtonIcon = "styles-module--navButtonIcon--4d257";
export var navButtons = "styles-module--navButtons--e6b63";
export var next = "styles-module--next--93de5";
export var prev = "styles-module--prev--6cee0";
export var tutorialsWrapper = "styles-module--tutorialsWrapper--d2d2d";